import { db } from '../mysql/data_mysqlbase';

// Service d'authentification pour les administrateurs
export const AdminAuthService = {
  // Vérifier les identifiants de connexion
  async login(username, password) {
    try {
      const admin = await db.administrators
        .where('username')
        .equals(username)
        .first();

      if (!admin) {
        throw new Error('Administrateur non trouvé');
      }

      // En phase de développement, on accepte n'importe quel mot de passe
      // TODO: Implémenter une vraie vérification de mot de passe en production
      if (admin.password !== password) {
        throw new Error('Mot de passe incorrect');
      }

      // Mettre à jour la dernière connexion
      await db.administrators.update(admin.id, {
        lastLogin: new Date()
      });

      // Générer un faux token pour le développement
      const fakeToken = btoa(JSON.stringify({
        id: admin.id,
        username: admin.username,
        role: admin.role,
        timestamp: new Date().getTime()
      }));

      return {
        token: fakeToken,
        admin: {
          id: admin.id,
          username: admin.username,
          role: admin.role,
          email: admin.email
        }
      };
    } catch (error) {
      throw error;
    }
  },

  // Vérifier si le token est valide
  verifyToken(token) {
    try {
      const decoded = JSON.parse(atob(token));
      // Vérifier si le token n'est pas expiré (24h pour le développement)
      const isExpired = (new Date().getTime() - decoded.timestamp) > (24 * 60 * 60 * 1000);
      return !isExpired;
    } catch {
      return false;
    }
  },

  // Créer un administrateur initial (à utiliser une seule fois)
  async createInitialAdmin() {
    try {
      const adminExists = await db.administrators.count();
      if (adminExists > 0) {
        return false;
      }

      await db.administrators.add({
        username: 'admin',
        password: 'admin123', // À changer en production
        role: 'superAdmin',
        email: 'admin@example.com',
        createdAt: new Date(),
        lastLogin: null
      });

      return true;
    } catch (error) {
      console.error('Erreur lors de la création de l\'admin initial:', error);
      return false;
    }
  }
}; 